module.exports = __webpack_public_path__ + "img/gb2238-80a-5-7.prt.715790eb.jpg";